import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAvalanche = function SvgAvalanche(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#E84142"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M63.59 17.811c-2.078-3.59-5.385-3.59-7.464 0L18.378 84.284c-2.079 3.637-.378 6.52 3.78 6.52h18.944a12 12 0 0 0 9.355-5.481L73.276 45.78a12.42 12.42 0 0 0 0-10.82l-6.804-11.952zM88.678 61.56c-2.079-3.59-5.433-3.59-7.512 0l-13.18 22.725c-2.032 3.59-.332 6.52 3.779 6.52h26.079c4.157 0 5.858-2.93 3.779-6.52z",
        clipRule: "evenodd"
    })));
};

export { SvgAvalanche as ReactComponent };
//# sourceMappingURL=Avalanche.svg.es.js.map
